<template>
    <div class="container pull-up">
        <div class="row">
            <div class="col-md-12">
                <div class="card m-b-30">
                    <div class="card-header">
                        <el-row type="flex" justify="end">
                            <el-col>
                                <div class="m-b-0 h5">
                                    <i class="mdi mdi-store-24-hour"></i> {{ $t('warehouse.button.all') }}
                                </div>
                            </el-col>
                            <el-col align="end">
                                <el-dropdown v-if="selectedWarehouses.length > 0" @command="handleDownload" split-button type="success"
                                           size="medium" class="m-r-10" :disabled="downloading">
                                    <i class="el-icon-download"></i> {{ $t('warehouse.button.download_stock_sheet') }} ({{ selectedWarehouses.length }})
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="pdf" :disabled="downloading">
                                            <i class="el-icon-document"></i> {{ $t('warehouse.button.download_pdf') }}
                                        </el-dropdown-item>
                                        <el-dropdown-item command="excel" :disabled="downloading">
                                            <i class="el-icon-s-grid"></i> {{ $t('warehouse.button.download_excel') }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-button v-can="'warehouse.create'" @click="showCreateDialog" icon="el-icon-plus"
                                           type="primary" plain round>
                                    {{ $t('warehouse.button.create') }}
                                </el-button>
                            </el-col>
                        </el-row>

                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <data-tables :data="warehouses"
                                         :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }"
                                         center-align
                                         @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column label="S/N" type="index" sortable></el-table-column>
                                <el-table-column prop="name" :label="$t('label.name')">
                                    <template slot-scope="scope">
                                        {{ scope.row.name }}
                                        <el-tag v-if="scope.row.default" size="small">
                                            {{ $t('label.default') }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="user.name" :label="$t('label.creator')"></el-table-column>
                                <el-table-column prop="created_at" :formatter="$shortDate"
                                                 :label="$t('label.created_at')"></el-table-column>
                                <el-table-column label="Actions" min-width="150px">
                                    <template slot-scope="scope">
                                        <el-dropdown v-can.event="'warehouse.manage'"
                                                     @click="$router.push({name: 'manage-warehouse', params: {id: scope.row.id}})"
                                                     split-button type="primary" size="small" trigger="click" class="m-r-5">
                                            <i class="el-icon-s-operation"></i> {{ $t('button.manage') }}
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item v-can.disable="'warehouse.edit'"
                                                                  @click.native="showEditDialog(scope.row.id)">
                                                    <i class="el-icon-edit"></i> {{ $t('button.edit') }}
                                                </el-dropdown-item>
                                                <el-dropdown-item v-can.disable="'warehouse.default'"
                                                                  :disabled="!!scope.row.default"
                                                                  @click.native="changeDefault(scope.row.id)">
                                                    <i class="el-icon-medal-1"></i> {{ $t('warehouse.button.default') }}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        <el-dropdown @command="(format) => handleWarehouseDownload(format, scope.row.id)"
                                                   split-button type="success" size="small" trigger="click"
                                                   :disabled="downloading || downloadingWarehouses.includes(scope.row.id)">
                                            <i class="el-icon-download"></i> {{ $t('warehouse.button.download') }}
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item command="pdf" :disabled="downloading || downloadingWarehouses.includes(scope.row.id)">
                                                    <i class="el-icon-document"></i> {{ $t('warehouse.button.download_pdf') }}
                                                </el-dropdown-item>
                                                <el-dropdown-item command="excel" :disabled="downloading || downloadingWarehouses.includes(scope.row.id)">
                                                    <i class="el-icon-s-grid"></i> {{ $t('warehouse.button.download_excel') }}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-edit-warehouse @created="newWarehouse" :display="displayEditDialog" @close="closeEditDialog"
                               @updated="departmentUpdate"
                               :warehouse="warehouse"></create-edit-warehouse>
    </div>
</template>

<script>
import CreateEditWarehouse from './Modal/CreateWarehouse'

export default {
  name: 'Index',
  components: {
    CreateEditWarehouse
  },
  data () {
    return {
      warehouses: [],
      warehouse: {},
      displayEditDialog: false,
      downloading: false,
      downloadingWarehouses: [],
      selectedWarehouses: []
    }
  },
  methods: {
    changeDefault (id) {
      this.askQuestion(this.$t('warehouse.confirm.default'), () => {
        this.$warehouseService.changeDefault(id).then(_ => {
          this.notify(this.$t('warehouse.message.default'))
          this.fetchWarehouses()
        })
      })
    },
    showCreateDialog () {
      this.warehouse = {}
      this.displayEditDialog = true
    },
    showEditDialog (id) {
      this.warehouse = this.warehouses.find(d => d.id === id)
      this.displayEditDialog = true
    },
    closeEditDialog () {
      this.warehouse = {}
      this.displayEditDialog = false
    },
    newWarehouse (data) {
      this.warehouses.push(data)
    },
    departmentUpdate (data) {
      this.warehouses.splice(this.warehouses.indexOf(this.warehouses.find(d => d.id === data.id)), 1, data)
    },
    showUsersDialog (id) {
    },
    beforeArchive (id) {
      this.askQuestion(this.$t('warehouse.message.archive'), () => {
        this.$departmentService.archiveDepartment(id).then(() => {
          this.notify(this.$t('warehouse.message.archived'))
          this.warehouses.splice(this.warehouses.indexOf(this.warehouses.find(d => d.id === id)), 1)
        })
      })
    },
    fetchWarehouses () {
      this.$warehouseService.getWarehouses().then(data => {
        this.warehouses = data
      })
    },
    handleSelectionChange (selection) {
      this.selectedWarehouses = selection.map(w => w.id)
    },
    async handleDownload (format) {
      if (this.downloading || this.selectedWarehouses.length === 0) {
        return
      }

      this.downloading = true
      try {
        await this.withLoading(async () => {
          let response
          const params = {
            warehouse_ids: this.selectedWarehouses
          }

          if (format === 'pdf') {
            response = await this.$warehouseService.downloadStockSheetPDF(params)
          } else if (format === 'excel') {
            response = await this.$warehouseService.downloadStockSheetExcel(params)
          } else {
            throw new Error('Invalid download format')
          }

          const prefix = this.selectedWarehouses.length === 1
            ? this.warehouses.find(w => w.id === this.selectedWarehouses[0])?.name.replace(/[^a-z0-9]/gi, '_').toLowerCase() || 'warehouse'
            : 'stock_sheet'

          this.processDownloadResponse(response, format, prefix)
          this.showSuccess(this.$t('warehouse.message.download_success'))
        }, 'downloading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in downloadStockSheet:', error)
        this.$message.error(this.$t('warehouse.error.download_failed'))
      } finally {
        this.downloading = false
      }
    },
    async handleWarehouseDownload (format, warehouseId) {
      if (this.downloading || this.downloadingWarehouses.includes(warehouseId)) {
        return
      }

      this.downloadingWarehouses.push(warehouseId)
      try {
        await this.withLoading(async () => {
          let response
          const params = {
            warehouse_ids: [warehouseId]
          }

          if (format === 'pdf') {
            response = await this.$warehouseService.downloadStockSheetPDF(params)
          } else if (format === 'excel') {
            response = await this.$warehouseService.downloadStockSheetExcel(params)
          } else {
            throw new Error('Invalid download format')
          }

          const warehouse = this.warehouses.find(w => w.id === warehouseId)
          const warehouseName = warehouse ? warehouse.name.replace(/[^a-z0-9]/gi, '_').toLowerCase() : `warehouse_${warehouseId}`

          this.processDownloadResponse(response, format, warehouseName)
          this.showSuccess(this.$t('warehouse.message.download_success'))
        }, 'downloading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in downloadWarehouseStockSheet:', error)
        this.$message.error(this.$t('warehouse.error.download_failed'))
      } finally {
        const index = this.downloadingWarehouses.indexOf(warehouseId)
        if (index > -1) {
          this.downloadingWarehouses.splice(index, 1)
        }
      }
    },
    processDownloadResponse (response, format, prefix = 'stock_sheet') {
      // Extract filename from response headers or use default
      const contentDisposition = response.headers['content-disposition']
      let filename = `${prefix}_${new Date().toISOString().split('T')[0]}.${format === 'pdf' ? 'pdf' : 'xlsx'}`

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '')
          // Decode URI if needed
          try {
            filename = decodeURIComponent(filename)
          } catch (e) {
            // If decoding fails, use as is
          }
        }
      }

      // Create download link
      const blob = new Blob([response.data], {
        type: format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('warehouse.title.warehouse'))
    try {
      await this.withLoading(async () => {
        const data = await this.$warehouseService.getWarehouses()
        this.warehouses = data
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getWarehouses:', error)
    }
  },
  created () {
    this.$parent.$on('new-warehouse', this.newWarehouse)
  }
}
</script>

<style scoped>
.m-r-10 {
  margin-right: 10px;
}
.m-r-5 {
  margin-right: 5px;
}
</style>
